module.exports = __webpack_public_path__ + "img/3_8.26da4115.png";